import logger from '../utils/rbmc.logger';
import plp from './rbmc.plp-services';
import spinner from '../utils/rbmc.spinner';

const loadMoreProducts = {
    bindHandler() {
        $(document.body).on('click', '.js-plp__btn--load-more', (evt) => {
            let self    = evt.currentTarget;
            let dataSet = self.dataset;
            spinner.spinnerVisibility(true);
            plp.fetchFragment(dataSet.href).then((data) => {
                        plp.appendProducts(data);
                        plp.replacePagination(data);
                    }, (jqXHR, textStatus) => {
                        logger.error(`loadMoreProducts failed: ${textStatus}`);
                    }
            ).always(() => {
                spinner.spinnerVisibility(false);
            });
        });
    }
};

$(() => {
    if ($('#product-grid-page').length) {
        loadMoreProducts.bindHandler();
    }
});

export default loadMoreProducts;
